import React, { useState, useEffect } from "react";
import axios from "axios";
import BASE_URL from "../config";
import "bootstrap/dist/css/bootstrap.min.css";

const SUBJECTS_API = `${BASE_URL}/api/subjects`;

const Subjects = () => {
  const [formData, setFormData] = useState({ SubjectName: "" });
  const [subjects, setSubjects] = useState([]);
  const [editId, setEditId] = useState(null);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  useEffect(() => {
    fetchSubjects();
  }, []);

  const fetchSubjects = async () => {
    try {
      const res = await axios.get(SUBJECTS_API);
      setSubjects(res.data);
    } catch (err) {
      console.error("Error fetching subjects", err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editId) {
        await axios.put(`${SUBJECTS_API}/${editId}`, {
          ...formData,
          UpdatedBy: "admin",
          UpdatedDate: new Date().toISOString().slice(0, 10),
        });
      } else {
        debugger;
        await axios.post(SUBJECTS_API, {
          ...formData,
          CreatedBy: "admin",
          CreatedDate: new Date().toISOString().slice(0, 10),
        });
      }
      setFormData({ SubjectName: "" });
      setEditId(null);
      fetchSubjects();
    } catch (err) {
      console.error("Error saving subject", err);
    }
  };

  const handleEdit = (subject) => {
    setFormData({ SubjectName: subject.SubjectName });
    setEditId(subject.SubjectID);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this subject?")) return;
    try {
      await axios.delete(`${SUBJECTS_API}/${id}`);
      fetchSubjects();
    } catch (err) {
      console.error("Error deleting subject", err);
    }
  };

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentSubjects = subjects.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(subjects.length / itemsPerPage);

  return (
    <div className="container mt-4">
      <h3>Subjects</h3>
      <form onSubmit={handleSubmit} className="row g-3 mb-4">
        <div className="col-md-6">
          <label className="form-label">Subject Name</label>
          <input
            type="text"
            name="SubjectName"
            className="form-control"
            value={formData.SubjectName}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-md-6 d-flex align-items-end">
          <button type="submit" className="btn btn-primary">
            {editId ? "Update Subject" : "Add Subject"}
          </button>
        </div>
      </form>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Subject ID</th>
            <th>Subject Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentSubjects.map((subject) => (
            <tr key={subject.SubjectID}>
              <td>{subject.SubjectID}</td>
              <td>{subject.SubjectName}</td>
              <td>
                <button
                  className="btn btn-sm btn-warning me-2"
                  onClick={() => handleEdit(subject)}
                >
                  Edit
                </button>
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => handleDelete(subject.SubjectID)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination Controls */}
      <nav>
        <ul className="pagination">
          {[...Array(totalPages)].map((_, idx) => (
            <li key={idx} className={`page-item ${currentPage === idx + 1 ? "active" : ""}`}>
              <button className="page-link" onClick={() => setCurrentPage(idx + 1)}>
                {idx + 1}
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default Subjects;
